module.exports = __webpack_public_path__ + "media/images/emblems/Gais-coat_of_arms-94c5e21d76087bf845e330bfadaac350.svg";